import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const WordformsExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Word Forms: Noun, Verb, Adjective, Adverb</h2>

      <p>
        In English, many words have different forms depending on their grammatical role — noun, verb, adjective, or adverb.
        Understanding these word forms helps you use words correctly in sentences.
      </p>

      <div className="grammar-flex-table">
        {[
          ['Noun', 'Verb', 'Adjective', 'Adverb'],
          ['optimization', 'optimize', 'optimized', 'optimizing'],
          ['deployment', 'deploy', 'deployed', 'deploying'],
          ['integration', 'integrate', 'integrated', 'integrating'],
          ['implementation', 'implement', 'implemented', 'implementing'],
          ['design', 'design', 'designed', 'designing'],
          ['quality', 'qualify', 'qualified', 'qualifying'],
          ['security', 'secure', 'secured', 'securing'],
          ['hosting', 'host', 'hosted', 'hosting'],
          ['recovery', 'recover', 'recovered', 'recovering'],
          ['updates', 'update', 'updated', 'updating'],
          ['innovation', 'innovate', 'innovative', 'innovating'],
          ['optimization', 'optimize', 'optimized', 'optimizing'],
          ['failure', 'fail', 'failed', 'failing'],
          ['distribution', 'distribute', 'distributed', 'distributing'],
          ['documentation', 'document', 'documented', 'documenting'],
          ['configuration', 'configure', 'configured', 'configuring'],
          ['training', 'train', 'trained', 'training'],
          ['computing', 'compute', 'computer', 'computed'],
          ['performance', 'perform', 'performed', 'performing'],
        ].map((row, index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            {row.map((cell, i) => (
              <div key={i} className="grammar-cell">{cell}</div>
            ))}
          </div>
        ))}
      </div>

      <div className="example-block">
        <h3><FaLightbulb /> Tip</h3>
        <p>Notice how the suffixes change: <strong>-tion/-sion</strong> for nouns, <strong>-ed/-ing</strong> for verb forms, <strong>-ive/-ed/-ing</strong> for adjectives, <strong>-ly</strong> for adverbs (though not all adverbs end in -ly). Learning these patterns helps you recognize and form new words.</p>
      </div>
    </div>
  );
};

export default WordformsExplanation;
